import { render, staticRenderFns } from "./customers-detail-table-panel.vue?vue&type=template&id=37680baa&scoped=true&lang=pug"
import script from "./customers-detail-table-panel.vue?vue&type=script&lang=js"
export * from "./customers-detail-table-panel.vue?vue&type=script&lang=js"
import style0 from "./customers-detail-table-panel.vue?vue&type=style&index=0&id=37680baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37680baa",
  null
  
)

export default component.exports